export class ApiError {
    message;
    code;

    constructor(message, code) {
        this.message = message;
        this.code = code;
    }
}